<input
    type="text"
    [value]="viewValue"
    [disabled]="isDisabled"
    [attr.id]="id"
    (change)="onChange($event)"
    (keypress)="onKeyPress($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (keyup)="onChange($event)">